import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import { useRefresh } from "ra-core";
import { useState } from "react";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { RefundTypeEnum } from "../../enums/RefundTypeEnum";
import EventBus from "../../EventBus";
import { PromotionalBalanceService } from "../../services/PromotionalBalanceService";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";

interface Props {
  balanceId: number;
  open: boolean;
  callback: () => void;
}

const promotionalBalanceService = new PromotionalBalanceService();

const PromotionalBalanceRefundDialog = (props: Props) => {
  const [refundType, setRefundType] = useState<RefundTypeEnum | null>(null);
  const [reason, setReason] = useState<string>("");
  const [amount, setAmount] = useState<string>("0");
  const refresh = useRefresh();

  const handleClose = () => {
    setRefundType(null);
    setReason("");
    setAmount("0");
    props.callback();
  };

  const handleSubmit = async () => {
    if (refundType === null) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Please select refund type",
        type: CustomSnackbarTypes.WARNING,
      });
      return;
    }
    if (!reason.trim()) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Please enter a reason",
        type: CustomSnackbarTypes.WARNING,
      });
      return;
    }
    if (refundType === RefundTypeEnum.PARTIAL && Number(amount) <= 0) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Enter a valid refund amount",
        type: CustomSnackbarTypes.WARNING,
      });
      return;
    }

    let payload: { refundType: string; reason: string; amount?: string } = {
      refundType,
      reason,
    };
    if (refundType === RefundTypeEnum.PARTIAL) {
      payload.amount = amount;
    }

    await promotionalBalanceService
      .initiateRefund(props.balanceId, payload)
      .then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Refund initiated successfully",
          type: CustomSnackbarTypes.SUCCESS,
        });
        refresh();
        handleClose();
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  return (
    <Dialog
      onClose={handleClose}
      open={props.open}
      scroll={"paper"}
      maxWidth="xs"
    >
      <DialogTitle>Refund Promotional Balance</DialogTitle>
      <DialogContent sx={{ width: 300 }}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Select refund type</InputLabel>
          <Select
            value={refundType}
            label="Select refund type"
            onChange={(event: any) => {
              setRefundType(event.target.value);
              setAmount("0");
            }}
          >
            {Object.values(RefundTypeEnum).map((val) => (
              <MenuItem key={val} value={val}>
                {val}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {refundType === RefundTypeEnum.PARTIAL && (
          <TextField
            fullWidth
            sx={{ mb: 2 }}
            value={amount}
            type={"number"}
            label={"Refund Amount (₹)"}
            InputProps={{ inputProps: { min: 1 } }}
            onChange={(event) => setAmount(event.target.value)}
          />
        )}
        <FormControl fullWidth>
          <TextField
            fullWidth
            value={reason}
            label={"Reason"}
            onChange={(event) => setReason(event.target.value)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSubmit} size={"large"}>
          Submit
        </Button>
        <Button
          variant="contained"
          color={"error"}
          onClick={handleClose}
          size={"large"}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromotionalBalanceRefundDialog;
